import { render, staticRenderFns } from "./AssessmentsGraph32.vue?vue&type=template&id=9badddb6"
import script from "./AssessmentsGraph32.vue?vue&type=script&lang=js"
export * from "./AssessmentsGraph32.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports